export enum SidebarGroupsEnum {
  company = 'company',
  sales = 'sales',
  cashiers = 'cashiers',
  purchases = 'purchases',
  products = 'products',
  marketing = 'marketing',
  stock = 'stock',
  configurations = 'configurations',
  home = 'home',
  banking = 'banking',
  financial = 'financial',
}
